import alcoholFreeIcon from 'assets/images/productPages/icon_alcohol_free.svg';
import crueltyFreeIcon from 'assets/images/productPages/icon_cruelty_free.svg';
import gmoFreeIcon from 'assets/images/productPages/icon_no_gmo.svg';
import parabenFreeIcon from 'assets/images/productPages/icon_paraben_free.svg';
import phtalateFreeIcon from 'assets/images/productPages/icon_phthalate_free.svg';
import sulfateFreeIcon from 'assets/images/productPages/icon_sulfate_free.svg';
import imageDesktop from 'assets/images/productPages/module_4_hero.jpg';
import imageMobile from 'assets/images/productPages/module_4_hero-m.jpg';

const cleanBeautyModule = {
  header: 'We believe in clean and responsible beauty.',
  description:
    'Every product we formulate is free of parabens, sulfates, phthalates, mineral oils, GMOs, and is always cruelty-free. ' +
    'Based on your preferences, we can make your formula vegan, silicone-free, or fragrance-free.',
  icons: [
    {
      icon: crueltyFreeIcon,
      legend: 'cruelty free',
      alt: 'cruelty free logo',
    },
    {
      icon: sulfateFreeIcon,
      legend: 'sulfate free',
      alt: 'sulfate free logo',
    },
    {
      icon: parabenFreeIcon,
      legend: 'paraben free',
      alt: 'paraben free logo',
    },
    {
      icon: gmoFreeIcon,
      legend: 'gmo free',
      alt: 'gmo free logo',
    },
    {
      icon: phtalateFreeIcon,
      legend: 'phthalate free',
      alt: 'phthalate free logo',
    },
    {
      icon: alcoholFreeIcon,
      legend: 'alcohol free',
      alt: 'alcohol free logo',
    },
  ],
  cta: 'View Our Full Ingredient List',
  hero: {
    imageDesktop,
    imageMobile,

    alt: 'Serene-looking blonde woman with eyes closed laying in grass with long blonde hair spread out around head.',
  },
};

export default cleanBeautyModule;
